import { BottomNavigation, TemplateWebPages } from "../../components";
import { Center, VStack } from "native-base";
import { platformWeb } from "../../utils";
import { Content } from "./Components";
import { FormContextProvider, NavigatorContextProvider } from "../../contexts";
import { ParamListBase } from "@react-navigation/native";
import { DrawerNavigationProp, DrawerScreenProps } from "@react-navigation/drawer";

export const ManagementApproved = ({
  navigation,
}: {
  navigation: DrawerNavigationProp<ParamListBase>;
}) => {
  return (
    <>
      <VStack flex={1}>
        {platformWeb ? (
          <TemplateWebPages navigation={navigation}>
            <Center>
              <Content />
            </Center>
          </TemplateWebPages>
        ) : (
          <>
            <Content />
            <BottomNavigation navigation={navigation} />
          </>
        )}
      </VStack>
    </>
  );
};

export const ManagementApprovedScreen = ({ navigation }: DrawerScreenProps<ParamListBase>) => {
  return (
    <NavigatorContextProvider>
      <FormContextProvider>
        <ManagementApproved navigation={navigation} />
      </FormContextProvider>
    </NavigatorContextProvider>
  );
};